import { c as _c } from "react/compiler-runtime";
import { diToFormData } from '@onefootprint/core';
import type { VaultData } from '@onefootprint/request-types';
import { Form } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { InvestorProfileFormData } from '../types';
export const EmploymentSection = () => {
  const $ = _c(45);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "collectInvestorProfile.employment"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  const {
    control
  } = useFormContext();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = diToFormData("investor_profile.employment_status");
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== control) {
    t2 = {
      control,
      name: t1
    };
    $[2] = control;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const employmentStatus = useWatch(t2);
  const isEmployed = employmentStatus === "employed";
  let t3;
  if ($[4] !== t) {
    t3 = t(_temp);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = {
      label: t3,
      value: "employed"
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp2);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = {
      label: t5,
      value: "unemployed"
    };
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t(_temp3);
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = {
      label: t7,
      value: "retired"
    };
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t(_temp4);
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = {
      label: t9,
      value: "student"
    };
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t4 || $[22] !== t6 || $[23] !== t8) {
    t11 = [t4, t6, t8, t10];
    $[20] = t10;
    $[21] = t4;
    $[22] = t6;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  const options = t11;
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = diToFormData("investor_profile.employment_status");
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t) {
    t13 = t(_temp5);
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t) {
    t14 = t(_temp6);
    $[28] = t;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t) {
    t15 = t(_temp7);
    $[30] = t;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t15) {
    t16 = {
      required: t15
    };
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== options || $[35] !== t13 || $[36] !== t14 || $[37] !== t16) {
    t17 = <Form.Select name={t12} label={t13} options={options} placeholder={t14} rules={t16} />;
    $[34] = options;
    $[35] = t13;
    $[36] = t14;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== isEmployed || $[40] !== t) {
    t18 = isEmployed && <><Form.Input name={diToFormData("investor_profile.occupation")} label={t(_temp8)} placeholder={t(_temp9)} data-dd-privacy="mask" rules={{
        required: t(_temp10)
      }} /><Form.Input name={diToFormData("investor_profile.employer")} label={t(_temp11)} placeholder={t(_temp12)} data-dd-privacy="mask" rules={{
        required: t(_temp13)
      }} /></>;
    $[39] = isEmployed;
    $[40] = t;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t17 || $[43] !== t18) {
    t19 = <section className="flex flex-col gap-6">{t17}{t18}</section>;
    $[42] = t17;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  return t19;
};
export default EmploymentSection;
function _temp($) {
  return $.employmentStatus.employed;
}
function _temp2($_0) {
  return $_0.employmentStatus.unemployed;
}
function _temp3($_1) {
  return $_1.employmentStatus.retired;
}
function _temp4($_2) {
  return $_2.employmentStatus.student;
}
function _temp5($_3) {
  return $_3.employmentStatus.label;
}
function _temp6($_4) {
  return $_4.employmentStatus.placeholder;
}
function _temp7($_5) {
  return $_5.employmentStatus.error;
}
function _temp8($_6) {
  return $_6.occupation.label;
}
function _temp9($_7) {
  return $_7.occupation.placeholder;
}
function _temp10($_8) {
  return $_8.occupation.error;
}
function _temp11($_9) {
  return $_9.employer.label;
}
function _temp12($_10) {
  return $_10.employer.placeholder;
}
function _temp13($_11) {
  return $_11.employer.error;
}